module.exports = __webpack_public_path__ + "img/43csm_Ersa-Wave-POWERFLOW-01-900x600_97e9351f72.b2bb907a.jpg";